import { React, Link } from "../../../common";
import Container from "../../container";

const Component = () => {
    return (
        <>
            <Container>
                <div id="container" >
                    <div id="content">
                        <div className="widthfix_10px">
                            <div className="preapprove_pgBlk">
                                <div className="preApprove_breadcrumb">Pre-Approval: Resume Saved Form</div>
                                <div className="savedApprovalLetterBlk">
                                    <div className="noContent" style={{ display: "none" }}>No saved forms available</div>

                                    <div className="savedApproval_head">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Property Address</td>
                                                    <td>Date &amp; Time</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="savedApproval">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td><Link to="">1900 Boothe Circle, Suite #100, Longwood, FL 32750</Link></td>
                                                    <td>12/25/2022 &nbsp; 13:16</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                                <tr>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container >
        </>
    )
}

export default Component;
